import { Spinner } from "@blueprintjs/core";
import * as React from "react";
import { useParams } from "react-router";

import { DysplasiaRequestApi, DysplasiaRequestDto, EPlatform, ERequestState, RequestDto } from "../../../../api";
import { PageContainer } from "../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalRequestResume } from "../../../common";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";
import { EDrupalRoutes } from "../../../EDrupalRoutes";
import { DrupalDysplasiaRequestForm } from "./DrupalDysplasiaRequestForm";

export interface IDrupalDysplasiaRequestPageProps {}

export const DrupalDysplasiaRequestPage: React.FunctionComponent<IDrupalDysplasiaRequestPageProps> = () => {
  const { id } = useParams<{ id: string }>();

  const dysplasiaRequestId = React.useMemo(() => +id, [id]);

  const { t } = useTl();
  const api = useApiService(DysplasiaRequestApi);
  // TODO-CRR : saving is used, but not saveItem???
  const { data, loading, saving } = useCrudApi<DysplasiaRequestDto>(
    React.useMemo(
      () => ({
        getApiFn: (apiId = dysplasiaRequestId) =>
          apiId > 0
            ? api.get(apiId)
            : new DysplasiaRequestDto({
                request: new RequestDto({
                  requestDate: new Date(),
                  status: ERequestState.REQUESTED,
                  platform: EPlatform.PORTAL,
                }),
              }).toJSON(),
        saveApiFn: (d: DysplasiaRequestDto) => api.save(DysplasiaRequestDto.fromJS({ ...d, isPortal: true })),
        onSavedRoute: (d) =>
          d.request.status === ERequestState.BILLED
            ? `${EDrupalRoutes.dysplasiaRequest}/${d.dysplasiaRequestId}`
            : EDrupalRoutes.requestList,
        deleteApiFn: () => {},
      }),
      [api, dysplasiaRequestId]
    ),
    [dysplasiaRequestId]
  );

  return loading ? (
    <Spinner />
  ) : (
    <PageContainer>
      <DrupalFieldSet title={`${t(ETLCodes.Payment)}: ${t(ETLCodes.DysplasiaRequest)}`}>
        <div>
          {saving ? (
            <Spinner />
          ) : (
            <DrupalRequestResume
              requestForm={
                <DrupalDysplasiaRequestForm
                  dysplasiaRequestId={dysplasiaRequestId}
                  initialdata={data}
                  loading={saving}
                />
              }
              requestDto={data?.request}
              bill={null}
            />
          )}
        </div>
      </DrupalFieldSet>
    </PageContainer>
  );
};
